import doc                from '@widesk-core/decorators/doc';
import ShopServiceModel   from '@/models/ShopServiceModel';

@doc.path('/stonecode_file_files/{?id}/_download_url')
export default class FileDownloadUrlModel extends ShopServiceModel {
    @doc.string declare url: string;
}
